import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.scss']
})
export class SuccessPageComponent implements OnInit {
  faArrowLeft = faArrowLeft
  constructor(
    private router: Router,
    private storageService:StorageService

  ) { }

  ngOnInit(): void {
  }

  stepOn(){
    this.router.navigate(['/'])
  }
}
